import styled from 'styled-components';

export const Root = styled.div`
  background-color: ${props => props.theme.colors.white};
  display: inline-grid;
  grid-template-columns: repeat(5, 1fr);
  grid-gap: 12px;
`;
